import React from 'react';

const MovieInformation = () => {
  console.log('MovieInformation');
  return (
    <div>MovieInformation</div>
  );
};

export default MovieInformation;
